<template>
  <div id="pageRoot">
    <img src="/pages/img/sordovio/assets_p40/titulo.svg" style="height: 55px; left: 50px; top: 60px; position: absolute;"/>

    <span class="normalTheme pageInstruction" style="left: 55px; top: 140px;">
      <p>Copia aquí el texto corregido.</p>
    </span>

    <img src="/pages/img/sordovio/assets_p40/caja.svg" style="width: 954px;
        height: 522px;
        left: 37px;
        top: 192px; 
        position: absolute;"/>

    <saved-input-long
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      maxlength="250"
      style="line-height: 74px"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 37px;
  top: 47px;
}
#inputField01 {
  position: absolute;
  width: 840px;
  height: 522px;
  left: 37px;
  top: 192px;
  margin-left: 50px;
  margin-top: 10px;
  font-size: 33px;
  font-family: "Courier New", Courier, monospace;
  font-weight: bold;
  z-index: 10;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["vio/Video 125.p4",]
    }
  }
}
</script>